module.exports = __webpack_public_path__ + "img/patrulla_estatal_down_selected.a07b4d90.svg";